import React from 'react';

// COMPONENT
import { ScreenDefault } from '../../ScreenDefault';

// SVG
import { RetentionSigned } from '../svgs';
import { ContentSteps, HeaderSteps, FinishedContainer, FinishedTitle, FinishedText, TitleSteps } from '../styles';

export const FinishRetention: React.FC = () => {
  return (
    <ContentSteps>
      <HeaderSteps>
        <TitleSteps>Concluído</TitleSteps>
      </HeaderSteps>
      <FinishedContainer>
        <RetentionSigned />
        <FinishedTitle>Assinatura finalizada!</FinishedTitle>
        <FinishedText>Agora é só aguardar nossa análise.</FinishedText>
      </FinishedContainer>
    </ContentSteps>
  );
};
